<template>
	<div class="icon-balance">
		<svg
			width="24.000000"
			height="24.000000"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			xmlns:xlink="http://www.w3.org/1999/xlink"
		>
			<desc>Created with Pixso.</desc>
			<defs>
				<clipPath id="clip85_1483">
					<rect
						id="search"
						width="24.000000"
						height="24.000000"
						fill="white"
						fill-opacity="0"
					/>
				</clipPath>
			</defs>
			<g clip-path="url(#clip85_1483)">
				<path
					id="path"
					d="M7.16 22.75C4.78 22.75 2.83 21.02 2.83 18.89L2.83 16.85C2.83 16.44 3.17 16.1 3.58 16.1C3.99 16.1 4.33 16.44 4.33 16.85C4.33 18.1 5.54 19.04 7.16 19.04C8.78 19.04 9.99 18.1 9.99 16.85C9.99 16.44 10.33 16.1 10.74 16.1C11.15 16.1 11.49 16.44 11.49 16.85L11.49 18.89C11.49 21.02 9.55 22.75 7.16 22.75ZM4.59 19.87C5.03 20.69 6.02 21.25 7.16 21.25C8.3 21.25 9.29 20.68 9.73 19.87C9.02 20.29 8.14 20.55 7.16 20.55C6.18 20.55 5.3 20.29 4.59 19.87Z"
					fill="#FFFFFF"
					fill-opacity="1.000000"
					fill-rule="evenodd"
				/>
				<path
					id="path"
					d="M7.16 17.79C5.52 17.79 4.05 17.04 3.32 15.85C3 15.33 2.83 14.73 2.83 14.1C2.83 13.05 3.29 12.07 4.13 11.34C5.75 9.92 8.54 9.92 10.17 11.34C11.01 12.08 11.48 13.05 11.48 14.1C11.48 14.73 11.31 15.33 10.99 15.85C10.27 17.04 8.8 17.79 7.16 17.79ZM7.16 11.75C6.38 11.75 5.66 12.01 5.12 12.48C4.61 12.91 4.33 13.5 4.33 14.1C4.33 14.46 4.42 14.78 4.6 15.08C5.06 15.84 6.04 16.3 7.16 16.3C8.28 16.3 9.26 15.84 9.71 15.09C9.89 14.8 9.98 14.47 9.98 14.11C9.98 13.51 9.7 12.92 9.19 12.48C8.66 12.01 7.94 11.75 7.16 11.75Z"
					fill="#FFFFFF"
					fill-opacity="1.000000"
					fill-rule="evenodd"
				/>
				<path
					id="path"
					d="M7.16 20.55C4.69 20.55 2.83 18.95 2.83 16.86L2.83 14.11C2.83 11.98 4.77 10.25 7.16 10.25C8.29 10.25 9.37 10.63 10.18 11.34C11.02 12.08 11.49 13.06 11.49 14.11L11.49 16.86C11.49 18.95 9.63 20.55 7.16 20.55ZM7.16 11.75C5.6 11.75 4.33 12.81 4.33 14.11L4.33 16.86C4.33 18.11 5.54 19.04 7.16 19.04C8.78 19.04 9.99 18.11 9.99 16.86L9.99 14.11C9.99 13.5 9.71 12.91 9.2 12.47C8.66 12.01 7.94 11.75 7.16 11.75Z"
					fill="#FFFFFF"
					fill-opacity="1.000000"
					fill-rule="evenodd"
				/>
				<path
					id="path"
					d="M19.03 14.8C17.52 14.8 16.24 13.68 16.12 12.24C16.04 11.41 16.34 10.6 16.95 10.01C17.45 9.49 18.15 9.2 18.9 9.2L20.99 9.2C21.98 9.23 22.74 10.01 22.74 10.97L22.74 13.03C22.74 13.99 21.98 14.77 21.02 14.8L19.03 14.8ZM20.97 10.7L18.91 10.7C18.56 10.7 18.24 10.83 18.01 11.07C17.72 11.35 17.59 11.73 17.62 12.11C17.67 12.77 18.31 13.3 19.03 13.3L20.99 13.3C21.12 13.3 21.24 13.18 21.24 13.03L21.24 10.97C21.24 10.82 21.12 10.71 20.97 10.7Z"
					fill="#FFFFFF"
					fill-opacity="1.000000"
					fill-rule="evenodd"
				/>
				<path
					id="path"
					d="M16 21.25L13.5 21.25C13.09 21.25 12.75 20.9 12.75 20.5C12.75 20.09 13.09 19.75 13.5 19.75L16 19.75C18.58 19.75 20.25 18.08 20.25 15.5L20.25 14.8L19.04 14.8C17.53 14.8 16.25 13.67 16.13 12.24C16.05 11.4 16.35 10.6 16.95 10.01C17.45 9.48 18.16 9.19 18.91 9.19L20.24 9.19L20.24 8.5C20.24 6.15 18.87 4.55 16.65 4.29C16.41 4.25 16.2 4.25 15.99 4.25L6.99 4.25C6.75 4.25 6.52 4.27 6.29 4.3C4.09 4.58 2.74 6.17 2.74 8.5L2.74 10.5C2.74 10.9 2.4 11.25 1.99 11.25C1.58 11.25 1.24 10.9 1.24 10.5L1.24 8.5C1.24 5.41 3.14 3.18 6.09 2.82C6.36 2.78 6.67 2.75 6.99 2.75L15.99 2.75C16.23 2.75 16.54 2.76 16.86 2.81C19.81 3.14 21.74 5.38 21.74 8.5L21.74 9.94C21.74 10.36 21.4 10.7 20.99 10.7L18.91 10.7C18.56 10.7 18.24 10.83 18.01 11.07C17.72 11.35 17.58 11.73 17.62 12.11C17.67 12.77 18.31 13.3 19.03 13.3L21 13.3C21.41 13.3 21.75 13.63 21.75 14.05L21.75 15.5C21.75 18.93 19.44 21.25 16 21.25Z"
					fill="#FFFFFF"
					fill-opacity="1.000000"
					fill-rule="evenodd"
				/>
			</g>
		</svg>
	</div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({})
export default class IconBalance extends Vue {}
</script>

<style scoped lang="scss">
.icon-balance {
	display: flex;
}
</style>
